// extracted by mini-css-extract-plugin
export default {"container":"Models_container__Lyi0P","block":"Models_block__PXyEh"};